import { EventEmitter } from 'events';

const eventEmitter: EventEmitter = new EventEmitter();
const s3imagesBucket = 'https://utopia-images.s3.eu-central-1.amazonaws.com';

const profilePics = {
  default: `${s3imagesBucket}/general/default.png`,
  governo: `${s3imagesBucket}/general/governo.jpg`,
  ministero: `${s3imagesBucket}/general/ministero.png`,
  commissione: `${s3imagesBucket}/general/commissione.png`,
  legislature: `${s3imagesBucket}/general/legislature.png`,
  camera: `${s3imagesBucket}/general/camera.jpg`,
  senato: `${s3imagesBucket}/general/senato.jpeg`,
  eu: `${s3imagesBucket}/general/flageu.png`,
  wikipedia: `${s3imagesBucket}/general/wikipedia.png`,
  google: `${s3imagesBucket}/general/google.png`,
};

// Same as BE
const perPage30 = 30;
const perPage50 = 50;
const perPage100 = 100;
const perPage250 = 250;
const sources = ['twitter', 'camera', 'senato', 'eu', 'region', 'other'];
const regionSources = ['ars', 'abruzzo', 'basilicata', 'campania', 'emiliaromagna', 'friuliveneziagiulia', 'lazio', 'liguria',
  'lombardia', 'marche', 'piemonte', 'puglia', 'toscana', 'umbria', 'veneto'];
const otherSources = ['manual', 'ade', 'adm', 'agcm', 'agcom', 'agenas', 'agid', 'aifa', 'anac', 'arera', 'art',
  'bancaditalia', 'beniculturali', 'bul', 'csaa24a25', 'confedersicurezza', 'consip', 'consob', 'covip', 'difesa', 'dipe',
  'enac', 'esteri', 'gazzetta', 'gpdp', 'gse', 'infratel', 'inps', 'interno', 'invitalia', 'iss', 'lavoro', 'masaf', 'mase',
  'mimit', 'mit', 'mur', 'pariopportunita', 'regioni', 'salute', 'statoregioni', 'turismo'];
const organs = ['Camera', 'Senato', 'European Parliament'];
// ---

const offices = ['Presidenza del consiglio', 'Affari esteri', 'Interno', 'Giustizia',
  'Difesa', 'Economia e Finanze', 'Imprese e Made in Italy', 'Agricoltura', 'Ambiente e Sicurezza energetica',
  'Infrastrutture e mobilità sostenibili', 'Lavoro e politiche sociali', 'Istruzione', 'Università e ricerca',
  'Cultura', 'Salute', 'Turismo'];
const officesNoPortfolio = [ 'Rapporti con il Parlamento', 'Riforme istituzionali', 'Innovazione tecnologica', 'Pubblica amministrazione',
  'Affari regionali e autonomie', 'Mare e Sud', 'Sport e giovani', 'Famiglia, natalità e pari opportunità',
  'Disabilità'];
const officesOther = ['Affari europei', 'Informazione ed editoria', 'Coordinamento della politica economica', 'Sicurezza della Repubblica',
  'Attuazione del programma di governo'];

const roles = ['Presidente', 'Vicepresidente', 'Vicepresidente Vicario', 'Portavoce', 'Ministro', 'Viceministro',
  'Segretario', 'Vicesegretario', 'Sottosegretario', 'Capogruppo', 'Tesoriere', 'Questore', 'Membro', 'Capo di Gabinetto',
  'Vice Capo di Gabinetto', 'Capo Ufficio Stampa', 'Capo Ufficio di Staff', 'Capo Ufficio Legislativo', 'Direttore Ufficio Legislativo',
  'Vicedirettore Ufficio Legislativo', 'Capo Segreteria', 'Segretario Generale', 'Segretario Particolare',
  'Capo Segreteria Tecnica', 'Segreteria Tecnica', 'Consigliere', 'Commissario', 'Assessore',
  'Presidente di regione', 'Sindaco', 'Vicesindaco', 'Politico', 'Ex politico'
];
const rolesMedia = ['Direttore', 'Vicedirettore', 'Vicedirettore Vicario', 'Direttore Responsabile', 'Capo Redattore',
  'Vice Capo Redattore', 'Redattore', 'Capo Servizio', 'Vice Capo Servizio', 'Produttore Esecutivo', 'Regia', 'Conduttore',
  'Autore', 'Inviato', 'Corrispondente', 'Collaboratore', 'Curatore', 'Editore', 'Giornalista'];
const rolesOther = ['Dirigente', 'Dirigente Generale', 'Direttore', 'Direttore Generale', 'Vicedirettore', 'Vicedirettore Generale',
  'Amministratore Delegato / CEO', 'Presidente di azienda', 'Vicepresidente di azienda', 'Capodelegazione', 'Coordinatore',
  'Docente', 'Partito', 'Ministero / Dipartimento', 'Autorità / Agenzia', 'Altro'];

const educations = ['Medie', 'Diploma', 'Laurea', 'Dottorato'];

const collegeRegions = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Friuli-Venezia Giulia',
  'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia',
  'Toscana', 'Trentino-Alto Adige', 'Umbria', 'Valle d\'Aosta', 'Veneto'];

const euCountries = ['Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czechia', 'Denmark', 'Estonia',
  'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg',
  'Malta', 'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia', 'Spain', 'Sweden'];

// EU Commissions (EN)
/*
'Foreign Affairs', 'Development', 'International Trade', 'Budgets', 'Budgetary Control', 'Economic and Monetary Affairs',
'Employment and Social Affairs', 'Environment, Public Health and Food Safety', 'Industry, Research and Energy',
'Internal Market and Consumer Protection', 'Transport and Tourism', 'Regional Development', 'Agriculture and Rural Development',
'Fisheries', 'Culture and Education', 'Legal Affairs', 'Civil Liberties, Justice and Home Affairs', 'Constitutional Affairs',
'Women’s Rights and Gender Equality', 'Petitions', 'Human Rights', 'Security and Defence', 'Tax Matters', 'Beating Cancer',
'Foreign Interference in all Democratic Processes in the European Union, including Disinformation',
'Artificial Intelligence in a Digital Age', 'Protection of Animals during Transport',
*/

// EU Commissions (IT)
/*
'Affari esteri', 'Sviluppo', 'Commercio internazionale', 'Bilanci', 'Controllo dei bilanci', 'Problemi economici e monetari',
'Occupazione e affari sociali', 'Ambiente, sanità pubblica e sicurezza alimentare', 'Industria, ricerca e energia',
'Mercato interno e protezione dei consumatori', 'Trasporti e turismo', 'Sviluppo regionale', 'Agricoltura e sviluppo rurale',
'Pesca', 'Cultura e istruzione', 'Giuridica', 'Libertà civili, giustizia e affari interni', 'Affari costituzionali',
'Diritti delle donne e uguaglianza di genere', 'Petizioni', 'Diritti dell'uomo', 'Sicurezza e difesa', 'Questioni fiscali',
'Lotta contro il cancro', 'Ingerenze straniere in tutti i processi democratici nell'Unione europea, inclusa la disinformazione',
'Intelligenza artificiale in un'era digitale', 'Protezione degli animali durante il trasporto',
*/

const clusters = ['Agricoltura', 'Ambiente', 'Appalti e Infrastrutture', 'Cultura', 'Difesa e Aerospazio', 'Digitale',
  'Economia e Finanza', 'Energia', 'Esteri', 'Food and Beverages', 'Industria e Commercio', 'Lavoro', 'Mobilità',
  'Sanità', 'Sicurezza', 'Telecomunicazioni', 'Temi sociali', 'Turismo'];
const categories = ['Unicorn', 'Platinum', 'Gold', 'Silver', 'Bronze', 'Wood'];

const departments = ['Public Affairs', 'Media Relations', 'Digital Affairs', 'UTOPIA Studios - URANIA', 'Legal Affairs', 'Administrative', 'Engineering'];
const guidelineDepartments = ['UTOPIA', 'UTOPIA EU', 'UTOPIA Studios - URANIA', 'Public Affairs', 'Media Relations', 'Digital Affairs', 'Legal Affairs', 'Administrative'];

const jobs = ['Trainee', 'Junior Account', 'Executive Account', 'Senior Account', 'Manager', 'Senior Manager', 'Board Member'];

const sites = ['Rome', 'Milan', 'Bruxelles'];

const activities = ['Backoffice', 'Content creation', 'Creative strategy', 'Digital', 'Event',
  'Interview / Op-ed / Article', 'Legislative', 'Media training', 'Meeting with Client', 'Meeting / Relationship with Institution',
  'Meeting with Media', 'Meeting with Team', 'Planning / Review', 'Press release', 'Round table', 'Social media training',
  'Talk', 'Tech', 'UTOPIA Studios - URANIA', 'Video interview'];

const statuses = ['Todo', 'Doing', 'Done', 'Goal achieved', 'Not done', 'Canceled'];

const formats = ['A View From Italy', 'Book Presentation', 'Casa Velardi', 'Connessioni', 'Digital Talk', 'Draft', 'Largo Chigi',
  `L'intervista`, 'Periscopio - visioni di prospettiva', 'Postilla', 'Radar', 'Strong-her', 'The Watcher Talk', 'Transatlantico'];

// 1 star, 2 star, 3 star, 4 star
const feedbacks = ['Negative', 'Neutral', 'Positive', 'Very Positive'];

const contracts = ['PA', 'Media', 'Digital', 'Legal', 'Studios - TV',
  'PA/Media', 'PA/Digital', 'PA/Legal', 'Media/Digital', 'Media/Legal', 'Digital/Legal',
  'PA/Media/Digital', 'PA/Digital/Legal', 'Media/Digital/Legal',
  'PA/Media/Digital/Legal'];

// Same as BE
const usernameRegexp = {
  twitter: /^[\w]{1,15}$/,
  instagram: /^[\w.]{1,30}$/,
  facebook: /^[\w.-]+$/,
  linkedin: /^[\wàèéìòù.-]+$/
};
const emailRegexp = '^.+@.+$';
const urlRegexp = '^https?://.+';
const dateRegexp = '[0-9]{4}-[0-9]{2}-[0-9]{2}';

// Charts
const chartOptions = {
  backgroundColors: ['#244c8a', '#624f99', '#984d9b', '#c74a91', '#ec4f7b',
    '#ff625d', '#ff823a', '#ffa600', '#ffd000', '#f2e311', '#d4e612', '#a8e312'],
  backgroundColorsSingleHue: [ '#244c8a', '#2c5d9a', '#366da9', '#417fb8', '#4d90c6', '#5aa2d5',
    '#69b4e3', '#78c6f1', '#89d8ff', '#a3e1ff', '#c2ebff', '#d9f2ff', '#c2ebff', '#a3e1ff',
    '#89d8ff', '#78c6f1', '#69b4e3', '#5aa2d5', '#4d90c6', '#417fb8', '#366da9', '#2c5d9a'],
  black: '#000000',
  bootstrapBlack: '#212529',
  fontSize: 14,
  fontTitle: {
    family: `'Arial', 'Helvetica', 'sans-serif'`,
    size: 20,
    weight: 'normal',
  },
  femaleColor: '#EC81A6',
  maleColor: '#57B7E6',
  onHover: (event: any, chartElement: any[]) => {
    event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
  },
  tooltipPercentage: {
    callbacks: {
      label: (context: any): string | string[] => `${context.label}: ${context.formattedValue}%`
    }
  },
  tooltipOpenTwitterOnClick: {
    callbacks: {
      label: (context: any): string | string[] => [`${context.dataset.label}: ${context.formattedValue}`, 'Click to open X']
    }
  },
  plugins: {
    openTwitterOnClick: {
      id: 'click-anywhere',
      afterEvent(chart, args) {
        if (args.event.type === 'click') {
          const value = chart.scales.y.getValueForPixel(args.event.y);
          const username = chart.data.labels[value];
          if (username) {
            window.open(`https://x.com/${username}`);
          }
        }
      }
    }
  }
};

const partyColors = {
  'Forza Italia': '#00a2e8',
  'FI': '#00a2e8',
  'Fratelli d\'Italia': '#0b3b6a',
  'FdI': '#0b3b6a',
  'Italia Viva': '#da2784',
  'IV': '#da2784',
  'Lega': '#33c819',
  'Liberi e Uguali': '#ee0000',
  'LeU': '#ee0000',
  'Misto': '#cccccc',
  'MoVimento 5 Stelle': '#f7ec2f',
  'M5S': '#f7ec2f',
  'No party': '#efefef',
  'Partito Democratico': '#ffa500',
  'PD': '#ffa500',
  'AVS': '#ffa500',
  'Alleanza Verdi e Sinistra': '#ffa500',
  'Tecnico': '#aaaaaa',
  'Tech': '#aaaaaa',
  '+Europa': '#92258e',
  '+Eu': '#92258e',
  'Azione': '#023494',
  'Az': '#023494',
  'Azione - Italia Viva': '#023494',
  'Az-IV': '#023494',
  'Per le Autonomie': '#cccccc',
  'Aut': '#cccccc',
  'MAIE': '#cccccc',
  'Coraggio Italia': '#e5277d',
  'CI': '#e5277d',
  'Insieme per il futuro': '#56b3c3',
  'Ipf': '#56b3c3',
  'Impegno Civico': '#56b3c3',
  'IC': '#56b3c3',
  'ID': '#11428a',
  'S&D': '#ff3a3a',
  'ECR': '#115ead',
  'PPE': '#2972b5',
  'Verdi/ALE': '#2c982b',
  'RE': '#4bbcfe',
  'NI': '#cccccc',
  'NGL': '#9ca5b1',
};

// Tests
const mockUser = {
  _id: '123',
  email: 'asd@example.com',
  permissions: []
};
const mockClient = {
  _id: '123',
  name: 'Client',
  _users: [],
  socials: [],
};
const mockOrganization = {
  _id: '123',
  name: 'Organization',
  _users: [],
  socials: [],
};
const mockRecord = {
  _user: {},
  _users: [],
  _politicians: [],
  _clients: [],
  _created_by: {},
  _organizations: [],
  departments: [],
  timesheet: [],
  comments: [],
};

export {
  eventEmitter as ee,
  profilePics,
  perPage30,
  perPage50,
  perPage100,
  perPage250,
  sources,
  regionSources,
  otherSources,
  organs,
  offices,
  officesNoPortfolio,
  officesOther,
  roles,
  rolesMedia,
  rolesOther,
  educations,
  collegeRegions,
  euCountries,
  clusters,
  categories,
  departments,
  guidelineDepartments,
  jobs,
  sites,
  activities,
  statuses,
  formats,
  feedbacks,
  contracts,
  usernameRegexp,
  emailRegexp,
  urlRegexp,
  dateRegexp,
  chartOptions,
  partyColors,
  // Tests
  mockUser,
  mockClient,
  mockOrganization,
  mockRecord,
};
